import React, { useEffect, useRef } from 'react';

const Features = () => {
  const featureRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    }, observerOptions);

    featureRefs.current.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => {
      featureRefs.current.forEach(el => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  const features = [
    {
      icon: '⚡',
      title: 'Lightning Fast',
      description: 'Get instant VAT calculations without any delays. Our optimized algorithm processes your calculations in milliseconds.'
    },
    {
      icon: '🎯',
      title: '100% Accurate',
      description: 'Precise calculations every time with support for multiple decimal places and rounding options.'
    },
    {
      icon: '🌍',
      title: 'Multi-Currency',
      description: 'Support for major global currencies including USD, EUR, GBP, and more.'
    },
    {
      icon: '📱',
      title: 'Mobile Friendly',
      description: 'Fully responsive design that works perfectly on all devices - desktop, tablet, and mobile.'
    },
    {
      icon: '🔒',
      title: 'Privacy First',
      description: 'All calculations are done locally in your browser. We don\'t store or transmit your data.'
    },
    {
      icon: '💼',
      title: 'Business Ready',
      description: 'Perfect for freelancers, small businesses, and enterprises. Quick preset VAT rates for convenience.'
    }
  ];

  return (
    <section className="features" id="features">
      <div className="features-container">
        <h2 className="section-title">Why Choose Our VAT Calculator?</h2>
        <p className="section-subtitle">Powerful features designed to make VAT calculations effortless</p>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="feature-card"
              ref={el => featureRefs.current[index] = el}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
